import { ArrowForward } from "@mui/icons-material";
import { Button, Divider, Stack, Typography } from "@mui/material";
import { ApiAuthUser } from "@incendium/api";

interface IOnboardingStepActionsProps {
  onNext?: () => void;
  nextLabel?: string;
  showNext?: boolean;
  onNextWithInvite?: () => void;
  inactiveUsers?: ApiAuthUser[];
}

function OnboardingStepActions({
  onNext,
  nextLabel = "Next",
  showNext = true,
  onNextWithInvite,
  inactiveUsers = [],
}: IOnboardingStepActionsProps) {
  return (
    <Stack spacing={2} sx={{ flexShrink: 0, pt: 2 }}>
      <Divider />
      {showNext && onNext && (
        <Button
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          endIcon={<ArrowForward />}
          onClick={onNext}
        >
          {nextLabel}
        </Button>
      )}
      {onNextWithInvite && (
        <Stack spacing={1}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            size="large"
            onClick={onNextWithInvite}
          >
            Approve & invite all inactive users
          </Button>
          {inactiveUsers.length > 0 && (
            <>
              <Typography variant="body2" color="error">
                {inactiveUsers.length} inactive users found — invite them to
                this project
              </Typography>
              {inactiveUsers.map((user) => (
                <Typography variant="body2" color="error" key={user.id}>
                  {user.name} ({user.email})
                </Typography>
              ))}
            </>
          )}
        </Stack>
      )}
    </Stack>
  );
}

export default OnboardingStepActions;
